// @ts-nocheck

import { __ } from '../../../i18n/l10n';

const { BoomSkinIds } = require('../types/global');

export const BoomLabelsBySkinId = {
  [BoomSkinIds.HALLOWEEN]: {
    OperationTitle: 'Boom Halloween',
    BetslipBandTitle: 'Boom Halloween',
    StepShortTitleByNbWonSteps: new Proxy(
      {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        '0': `${__('Level %1$s', 1)}`,
        '1': `${__('Level %1$s', 2)}`,
        '2': `${__('Level %1$s', 3)}`,
        '3': `${__('Level %1$s', 4)}`,
        '4': `${__('Level %1$s', 5)}`,
        '5': '',
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return '';
          }
          return origin[key];
        },
      },
    ),
    StepShortTitleByStepId: new Proxy(
      {
        STEP_1: `${__('Level %1$s', 1)}`,
        STEP_2: `${__('Level %1$s', 2)}`,
        STEP_3: `${__('Level %1$s', 3)}`,
        STEP_4: `${__('Level %1$s', 4)}`,
        STEP_5: `${__('Level %1$s', 5)}`,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return '';
          }
          return origin[key];
        },
      },
    ),
    WelcomeContent: `🎃 ${__('Explode your pumpkin by winnings 5 bets')}`,
  },
  [BoomSkinIds.VALENTINE]: {
    OperationTitle: __('Boom St Valentine'),
    BetslipBandTitle: __('Boom St Valentine'),
    StepShortTitleByNbWonSteps: new Proxy(
      {
        '0': `${__('Level %1$s', 1)}`,
        '1': `${__('Level %1$s', 2)}`,
        '2': `${__('Level %1$s', 3)}`,
        '3': `${__('Level %1$s', 4)}`,
        '4': `${__('Level %1$s', 5)}`,
        '5': '',
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return '';
          }
          return origin[key];
        },
      },
    ),
    StepShortTitleByStepId: new Proxy(
      {
        STEP_1: `${__('Level %1$s', 1)}`,
        STEP_2: `${__('Level %1$s', 2)}`,
        STEP_3: `${__('Level %1$s', 3)}`,
        STEP_4: `${__('Level %1$s', 4)}`,
        STEP_5: `${__('Level %1$s', 5)}`,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return '';
          }
          return origin[key];
        },
      },
    ),
    WelcomeContent: `❤️ ${__('Explode Cupid by winnings 5 bets')}`,
  },
  [BoomSkinIds.PATRICK]: {
    OperationTitle: 'Boom St Patrick',
    BetslipBandTitle: 'Boom St Patrick',
    StepShortTitleByNbWonSteps: new Proxy(
      {
        '0': `${__('Level %1$s', 1)}`,
        '1': `${__('Level %1$s', 2)}`,
        '2': `${__('Level %1$s', 3)}`,
        '3': `${__('Level %1$s', 4)}`,
        '4': `${__('Level %1$s', 5)}`,
        '5': '',
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return '';
          }
          return origin[key];
        },
      },
    ),
    StepShortTitleByStepId: new Proxy(
      {
        STEP_1: `${__('Level %1$s', 1)}`,
        STEP_2: `${__('Level %1$s', 2)}`,
        STEP_3: `${__('Level %1$s', 3)}`,
        STEP_4: `${__('Level %1$s', 4)}`,
        STEP_5: `${__('Level %1$s', 5)}`,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return '';
          }
          return origin[key];
        },
      },
    ),
    WelcomeContent: `🍀 ${__('Explode the leprechaun by winnings 5 bets')}`,
  },
};
